import {useMemo} from 'react';
import usePermissionStatus from './useHasPermission';
import useMe from './useMe';

function usePermissionStatusByKey(permissionKey) {
    const {getPermissionStatus} = usePermissionStatus();
    const {data: currentUser} = useMe();
    return useMemo(() => {
        return currentUser?.role === 'Admin' ? true : getPermissionStatus(permissionKey);
    }, [currentUser?.role, getPermissionStatus, permissionKey]);
}

export default usePermissionStatusByKey;
